/*-------------  NAVIGATION  -------------*/




/*
function nav_top_menu() {
				$('#tmi1').click();

$(".tmi").on("click",function(){
	var id = $(this).attr("id");
	$(".tmi").removeClass('active');
	$(".slide").html('');
	$(".slide").hide();
	$(this).addClass("active");
	cont = '';
	bmcont = '';

	switch (id) {
		case "tmi1":
		slide1_anima();
		break;
		case "tmi2":
		slide2_anima();
		break;
		case "tmi3":
		slide3_anima();
		break;
		case "tmi4":
		slide4_anima();
		break;
		case "tmi5":
		slide5_anima();
		break;
		case "tmi6":
		slide6_anima();
		break;
	};
});
}
*/

/* Create Elements funcs */

function CreateElements1(data1) {

	$.each( data1, function( key, val ) {

		if (key.substr(0,5) == "descr") {

			var point = '<div class="slide1_descr" id="slide1_'+key+'">'+val.label+'</div>';

			window.elements1[key] = new Element(key, false, point);

		}
		else if (key.substr(0,7) == "ethanol") {

			if (key == "ethanols") {

				var point = '<div class="slide1_box"><div class="slide1_box_headline">'+val.label+'</div></div>';

				window.elements1[key] = new Element(key, false, point);
			}
			else {

				var point = "<div class='tabcircle_l_pos' id='tabcircle_pos_"+key+"' data-clicked='"+key+"'>";
				point += "<div class='tabcircle_l_anim pulsateMEtab'></div>";
				point += "<div class='tabcircle_l' id='tabcircle_l_"+key+"'></div>";
				point += "<div class='tabcircle_l_over' id='tabcircle_over_"+key+"'></div>";
				point += "<div class='tabcircle_l_label' id='tabcircle_l_label_"+key+"' data-clicked='"+key+"'>"+val.label+"</div>";
				point += "</div>";

				var banner = '<div class="slide1_banner" id="slide1_'+key+'">';
				banner += '<div class="slide1_banner_text" id="slide1_text_'+key+'"><b>'+val.headline+'</b><br><br>'+val.text+'<div class="banner_close_s" id="close_'+key+'" data-clicked="'+key+'"></div></div></div>';

				window.elements1[key] = new Element(key, banner, point);
			}
		}

	});
}



/*

function nextSlide() {

	if (activeScene<3) {

console.log(activeScene);
		activeScene++;
console.log(activeScene);

		$(".slide").removeClass('active');
 		$(".screen_"+activeScene).addClass('active');

		$('#left').show();

		if (activeScene != 3) {
			$('#right').show();
		}
		else {
			$('#right').hide();
		}

		if (activeScene == 2) {
			slide2_animation1();
				$("#circle_over_banner11").addClass("circle_over_inv");
		}
		if (activeScene == 3) {
			slide3_animation1();
				$("#circle_over_banner21").addClass("circle_over_inv");
		}
 	}
}


function prevSlide() {

	if (activeScene>1) {

console.log(activeScene);
 		activeScene--;
console.log(activeScene);

		if (activeScene != 1) {
			$('#left').show();
		} else {
			$('#left').hide();
		}

 		$(".slide").removeClass('active');
 		$(".screen_"+activeScene).addClass('active');

		if (activeScene == 1) {
			slide1_animation1();
				$("#circle_over_banner1").addClass("circle_over_inv");
		}
		if (activeScene == 2) {
			slide2_animation1();
				$("#circle_over_banner11").addClass("circle_over_inv");
		}
		if (activeScene == 3) {
			slide3_animation1();
				$("#circle_over_banner21").addClass("circle_over_inv");
		}

		$('#right').show();

 	}
}
*/

$(document).ready(function() {

	//getHash();

	//getDataJSON("10wOQZFi_kkcGHFTwGfjDljk9vlHMPbfDjR9mBvhMoh8", "2015_12_zelpo2", ver);

	$(document).on("click", "#bigcircle_pos_start", function(event) {
		$('#preload').fadeOut(1000,"easeOutCirc");
		top_menu();
		slide1_anima();
		$('#tmi1').addClass('active');
	});

});
